import axios from 'axios'
import jwtDefaultConfig from './jwtDefaultConfig'
export default class JwtService {
  // ** jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig }

  // ** For Refreshing Token
  isAlreadyFetchingAccessToken = false

  // ** For Refreshing Token
  subscribers = []

  // ** Set once a forced logout has started
  isForcingLogout = false

  constructor(jwtOverrideConfig) {
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }

    // ** Request Interceptor
    axios.interceptors.request.use(
      config => {
        if (this.isForcingLogout) {
          return Promise.reject(new axios.Cancel('Session has ended'))
        }
        
        // ** Get token from localStorage
        const accessToken = this.getToken()

        // ** If token is present add it to request's Authorization Header
        if (accessToken) {
          // ** eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
        }
        
        window.$isLoading = true
     
        return config
      },
      error => { 
        Promise.reject(error)
      }
    )

    // ** Add request/response interceptor
    axios.interceptors.response.use(
      
      response => {
        return response
     
     },
      error => {
       
        const { response } = error

        // ** SessionInvalid covers disabled accounts and expired driver sessions.
        // ** Other 401 responses (e.g. third-party map services) are passed through unchanged.
        // ** The API serialises JSON in camelCase (sessionInvalid/message); PascalCase is accepted too.
        const data = response && response.data
        if (response && response.status === 401 && data && (data.sessionInvalid === true || data.SessionInvalid === true)) {
          this.forceLogout(data.message || data.Message)
        }
        return Promise.reject(error)
      }
      
   
    )
    
  }

  forceLogout(message) {
    // ** Several requests can fail together; only log out once.
    if (this.isForcingLogout) return
    this.isForcingLogout = true

    // ** Drop the token first so no further request (including the login page) sends it.
    // ** companyID and staffRoleID are kept because handleLogout uses them for the redirect.
    localStorage.removeItem(this.jwtConfig.storageTokenKeyName)
    localStorage.removeItem('userToken')
    localStorage.removeItem('Headers')

    // ** Loaded lazily to avoid a circular import (the store imports this service).
    const { store } = require('@store/store')
    const { handleLogout } = require('@store/authentication')
    const swalModule = require('sweetalert2')
    const Swal = swalModule.default || swalModule

    Swal.fire({
      icon: 'error',
      title: '',
      text: message || 'Your account has been disabled. Please contact your administrator.',
      allowOutsideClick: false,
      customClass: {
        confirmButton: 'btn btn-sm btn-success'
      },
      buttonsStyling: false
    }).then(() => {
      store.dispatch(handleLogout())
    })
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter(callback => callback(accessToken))
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }

  getToken() {
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName)
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName)
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value)
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value)
  }

  login(...args) {
    return axios.post(this.jwtConfig.loginEndpoint, ...args)
  }

  register(...args) {
    return axios.post(this.jwtConfig.registerEndpoint, ...args)
  }

  refreshToken() {
    return axios.post(this.jwtConfig.refreshEndpoint, {
      refreshToken: this.getRefreshToken()
    })
  }
 
}
